module.exports = __webpack_public_path__ + "static/media/Bio16.eba99af9.png";